import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import useIntercom, { loadIntercom } from 'modules/onboarding/hooks/useIntercom'
import ProductUpdatesToursList from 'modules/product_updates/components/ProductUpdatesTourList'
import useToursData from 'modules/product_updates/hooks/useTourData'

const Content: React.FC = () => {
  const session = useCurrentSession()
  const { intercomApiBase, intercomApiId } = React.useContext(EnvironmentContext)

  const {
    email,
    access: { id: userId, firstName, lastName },
    company: {
      id: companyId,
      name: companyName,
      size: companySize,
      industry: companyIndustry,
      createdAt: companyCreatedAt,
      legalEntities,
    },
    employee,
    isIntercomAllowed,
  } = session

  const userIsAdmin = false

  const { handleStartTour } = useIntercom({
    isIntercomAllowed,
    userIsAdmin,
    userName: `${firstName} ${lastName}`,
    userId,
    userEmail: email,
    userPhone: employee?.phoneNumber ?? '',
    companyId,
    companyName,
    companySize,
    companyIndustry,
    companyCreatedAt,
    companyCountry: legalEntities[0]?.country ?? '',
  })

  React.useEffect(() => {
    loadIntercom({
      isIntercomAllowed,
      intercomApiBase,
      intercomApiId,
      userIsAdmin,
      userName: `${firstName} ${lastName}`,
      userId,
      userEmail: email,
      userPhone: employee?.phoneNumber ?? '',
      companyId,
      companyName,
      companySize,
      companyIndustry,
      companyCreatedAt,
      companyCountry: legalEntities[0]?.country ?? '',
    })
  }, [
    isIntercomAllowed,
    intercomApiBase,
    intercomApiId,
    userIsAdmin,
    firstName,
    lastName,
    userId,
    email,
    employee,
    companyId,
    companyName,
    companySize,
    companyIndustry,
    companyCreatedAt,
    legalEntities,
  ])

  const { groupedTours } = useToursData(handleStartTour)
  if (!groupedTours) {
    return null
  }

  return (
    <Box justifyContent="flexStart">
      <Box gap="s32">
        {Object.keys(groupedTours).map((group, index) => (
          <ProductUpdatesToursList
            key={group}
            position={index + 1}
            title={group}
            tours={groupedTours[group] || []}
          />
        ))}
      </Box>
    </Box>
  )
}

export default Content
